module.exports = __webpack_public_path__ + "static/0043-c8830c2063c8f3aa9e555be2112fad79.png";